import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown } from "../../../common/component/Index";
import Baggage from './../../../../../models/Baggage';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import { PATHS } from '../../../../../constants/Define';
import moment from "moment";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import EllipsisText from '../../../common/component/EllipsisText';

const ListCols = ['airlineCode', 'class', 'handBaggage', 'baggageAllowance', 'isDomestic'];
const ModelFields = Object.getOwnPropertyNames(new Baggage());

class BaggageList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                isDomestic: {
                    key: 'isDomestic',
                    render: (text, record) => text ? this.props.t(`item.baggage.domestic`) : this.props.t(`item.baggage.international`)
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record)
                }
            },
            filters: {},
            expandedRows: []
        };
    }

    render() {
        const { t, loading, pagination, baggages } = this.props;
        const { titleItemTable, modelItem, componentTable, expandedRows } = this.state;
        return (
            <ListComponent
                tableKey="baggages-list"
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(baggages || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'baggage'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                onColumnVisibleChange={this.onColumnVisibleChange}
                expandedRowKeys={expandedRows}
                onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
            />
        );
    }
    
    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeBaggage = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.baggage.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeBaggage,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.BAGGAGE.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    getTableColumns() {
        return Func.getTitleTable([ListCols], ['action'], []);
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }


}

export default withTranslation()(BaggageList);